/**
 * Created by zzy on 2019/7/24.
 */
import AppBreadcrumb from './AppBreadcrumb.vue'
export default AppBreadcrumb



// WEBPACK FOOTER //
// ./src/components/appBreadcrumb/index.js